import {ReactComponent as PlusIcon} from '../assets/image/plus.svg';
import React from "react";
import {get, toNumber} from "lodash";
import AppSettingController from "../../Main/controller/AppSettingController";
import DiscountController from "../Controller/DiscountController";
import InvoiceInterface from "../interface/invoiceInterface";
import marketSettingLocalStorage from "../../Main/interface/MarketSettingLocalStorage";
import {useTranslation} from "react-i18next";

export default function ShowDiscount({state, setState}: {
    state: InvoiceInterface,
    setState: React.Dispatch<React.SetStateAction<InvoiceInterface>>
}) {
    const {t, i18n} = useTranslation();
    const setting = AppSettingController.getSetting() as marketSettingLocalStorage;
    const currency = setting.currency || t("currency.default");
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    if (AppSettingController.isHiddenPrice())
        return null

    if (!state.discount.isApplyDiscount)
        return null

    return (
        <div className="toggle-form-discount">
            <div>
                <PlusIcon onClick={() => new DiscountController(state, setState).clearDiscount()}/>
                <p>{t("invoice.showDiscount")}</p>
            </div>
            {state.discount.type === 'price' ?
                <p>{new Intl.NumberFormat(lang).format(toNumber(get(state.discount, "discountPrice", 0)))} {currency}</p> :
                <p>{get(state.discount, "discountPercentage", 0)}%</p>}
        </div>
    );
}